import { Action, Shell, UserActionTypes, UserState, userStore } from '@infra/application-shell'
import { psPatientsTheme } from '@infra/ui-design-system'
import {FC, ReactElement} from 'react'
import { BrowserRouter } from 'react-router-dom'
import { i18n } from './i18n'
import { PrescriptionStoreProvider } from './shared/stores/PrescriptionStore'
import CookieBot from 'react-cookiebot';
import {TrackingTools} from "@/shared/components/TrackingTools";
import {Box} from "@mui/material";

export const storeReducer = (state: UserState, action: Action<UserActionTypes>) => {
  switch (action.type) {
    case UserActionTypes.SET_USER_ERROR:
      return { ...state, error: action.payload }
    case UserActionTypes.SET_USER_INFO:
      return {
        ...state,
        user: {
          ...action.payload,
        },
      }
    case UserActionTypes.CLEAR_USER:
      return {
        ...state,
        user: {},
      }
    default:
      return state
  }
}

const userStoreCreate = userStore(storeReducer)

interface AppShellProps {
  children: NonNullable<ReactElement>
}

const AppShell: FC<AppShellProps> = ({ children }) => {
  return <Box>
    <CookieBot domainGroupId={'fb568c64-3002-467d-93b1-79863fd2aa42'} />
    <TrackingTools />
    <BrowserRouter>
      <Shell theme={psPatientsTheme} i18n={i18n} userStoreCreate={userStoreCreate}>
        <PrescriptionStoreProvider>{children}</PrescriptionStoreProvider>
      </Shell>
    </BrowserRouter>
  </Box>
}

export { AppShell, userStoreCreate }
